import React from 'react'
import styled from '@emotion/styled'

const Icon = styled.svg`
  .cls-1 {
    fill: #fff;
    fill-rule: evenodd;
  }

  .cls-2,
  .cls-3 {
    fill: none;
    stroke: #fff;
    stroke-width: 2px;
  }

  .cls-3 {
    stroke-linecap: round;
    stroke-dasharray: 1 6 1 6;
  }
`

export const SurfaceWaterIcon = () => {
  return (
    <Icon viewBox="0 0 70 70.71">
      <g id="surface_icon" data-name="surface icon">
        <polygon
          id="Fill-93-Copy"
          className="cls-1"
          points="0.1 23.17 23.34 0 31.04 0.05 46.34 15.69 46.1 54.55 30.6 70 15.2 69.9 15.3 54.36 0 38.72 0.1 23.17"
        />
        <polyline
          id="Path-8"
          className="cls-2"
          points="40.34 70 53.96 56.58 69.99 56.63"
        />
        <path
          id="Path-9"
          className="cls-3"
          d="M58.82,55.7l.07-11.56,8.6-6.33"
        />
      </g>
    </Icon>
  )
}
